import type { IcIcon } from "./types";

export const IcMinus: IcIcon = (properties) => (
  <svg viewBox="0 0 24 24" {...properties}>
    <line stroke="currentColor" x1="7" x2="17" y1="12" y2="12" />
  </svg>
);
